module.exports = __webpack_public_path__ + "static/img/logo1173.473c10c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1173.png
// module id = DdZS
// module chunks = 9